module.exports = __webpack_public_path__ + "img/dxal.7645ce9b.png";